module.exports = __webpack_public_path__ + "img/cliente1.eae1aa07.jpg";